module.exports = __webpack_public_path__ + "static/media/transition_icon.ab72e5b8.svg";